import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState = {
    notifications: [],
}

const notifierSlice = createSlice({
    name: `notifier`,
    initialState,
    reducers: {
        enqueueSnackbar: {
            reducer: (state, action: PayloadAction<any>) => ({
                ...state,
                notifications: [
                    ...state.notifications,
                    {
                        key: action.payload.key,
                        ...action.payload,
                    },
                ],
            }),
            prepare: (notification) => {
                const key = notification.options && notification.options.key

                return {
                    payload: {
                        ...notification,
                        key: key || Date.now() + Math.random(),
                    },
                }
            },
        },
        removeSnackbar: (state, action: PayloadAction<string | number>) => ({
            ...state,
            notifications: state.notifications.filter((notification) => notification.key !== action.payload),
        }),
    },
})

export const notifierActions = notifierSlice.actions

export default notifierSlice.reducer
